// Jet OnboardingStepShow/Done for pages OUTSIDE the builder funnel runtime
// (mini-games, CRM 1click pages). Mirrors useOnboardingStepEvents semantics:
// same step-id hash, same sessionStorage chain (jet_last_step), so standalone
// steps link into the funnel step sequence via previous_*.
// Builder-funnel-only flags (is_backwards / is_control / is_conditional /
// is_variation / is_step_back) are intentionally NOT sent.
import Jet from '@/modules/Jet'
import {
	STEP_TYPE,
	jetGenerateStepId,
	jetComputeSecondsOnScreen,
	persistStepState,
	readPersistedStepState,
} from '@/composables/stepEventsCore'

// Module-level: a single "current standalone step", like stepEvents in
// useOnboardingStepEvents. doneSent guards double-fire (e.g. payment retry
// after error) — reset by the next stepShow.
const state = {
	stepId: null,
	title: '',
	stepType: STEP_TYPE.OTHER,
	previousStepId: null,
	previousTitle: '',
	showTimestamp: null,
	doneSent: false,
}

function stepShow({ title, stepType }) {
	const lastStep = readPersistedStepState()

	state.previousStepId = lastStep?.stepId || null
	state.previousTitle = lastStep?.title || ''
	state.stepId = jetGenerateStepId(title)
	state.title = title
	state.stepType = stepType
	state.showTimestamp = Date.now()
	state.doneSent = false
	persistStepState(state.stepId, state.title)

	Jet.track('OnboardingStepShow', {
		onboarding_step_id: state.stepId,
		...(state.previousStepId && { previous_onboarding_step_id: state.previousStepId }),
		onboarding_title: state.title,
		...(state.previousTitle && { previous_onboarding_title: state.previousTitle }),
		step_type: state.stepType,
	})
}

function stepDone({ data } = {}) {
	if (!state.stepId || state.doneSent) return

	state.doneSent = true
	const secondsOnScreen = jetComputeSecondsOnScreen(state.showTimestamp)
	const answer = data || {}

	Jet.track('OnboardingStepDone', {
		onboarding_step_id: state.stepId,
		...(state.previousStepId && { previous_onboarding_step_id: state.previousStepId }),
		onboarding_title: state.title,
		...(state.previousTitle && { previous_onboarding_title: state.previousTitle }),
		step_type: state.stepType,
		...(secondsOnScreen !== null && { seconds_on_screen: secondsOnScreen }),
		...(answer.data_string != null && { data_string: answer.data_string }),
		...(answer.data_float != null && { data_float: String(answer.data_float) }),
		...(answer.data_int != null && { data_int: answer.data_int }),
		data_array: [],
	})
}

export function useStandaloneStepEvents() {
	return { stepShow, stepDone, STEP_TYPE }
}
